export default __webpack_public_path__ + "static/lipetsk-fbdb7dd45131d3fb89f9ed2b14d88991.webp";